import React, { useEffect, useState } from "react";
//Bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function IncomeTableRows({
  id,
  row,
  addRow,
  removeRow,
  setField,
  incomeRows,
}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (row.id === incomeRows[incomeRows.length - 1].id) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [incomeRows]);
  return (
    <tr key={id}>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <Form.Control
              type="text"
              className="incomeTableInput"
              placeholder="Title"
              value={row.title}
              onChange={(e) => setField("title", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeOne === 0 ? undefined : row.incomeOne}
              placeholder="Amt"
              onChange={(e) => setField("incomeOne", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeTwo === 0 ? undefined : row.incomeTwo}
              placeholder="Amt"
              onChange={(e) => setField("incomeTwo", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeThree === 0 ? undefined : row.incomeThree}
              placeholder="Amt"
              onChange={(e) => setField("incomeThree", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeFour === 0 ? undefined : row.incomeFour}
              placeholder="Amt"
              onChange={(e) => setField("incomeFour", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeFive === 0 ? undefined : row.incomeFive}
              placeholder="Amt"
              onChange={(e) => setField("incomeFive", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeSix === 0 ? undefined : row.incomeSix}
              placeholder="Amt"
              onChange={(e) => setField("incomeSix", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeSeven === 0 ? undefined : row.incomeSeven}
              placeholder="Amt"
              onChange={(e) => setField("incomeSeven", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeEight === 0 ? undefined : row.incomeEight}
              placeholder="Amt"
              onChange={(e) => setField("incomeEight", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeNine === 0 ? undefined : row.incomeNine}
              placeholder="Amt"
              onChange={(e) => setField("incomeNine", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeTen === 0 ? undefined : row.incomeTen}
              placeholder="Amt"
              onChange={(e) => setField("incomeTen", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeEleven === 0 ? undefined : row.incomeEleven}
              placeholder="Amt"
              onChange={(e) => setField("incomeEleven", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={row.incomeTwelve === 0 ? undefined : row.incomeTwelve}
              placeholder="Amt"
              onChange={(e) => setField("incomeTwelve", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td className="hideBorders col-1">
        {show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="incomeNavcolour me-3"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {!show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="incomeNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {show && (
          <Button
            onClick={() => {
              addRow(id);
              setShow(false);
            }}
            type="button"
            className="incomeNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faPlus} />
          </Button>
        )}
      </td>
    </tr>
  );
}
